"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleInfoDataRow = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
require("./types");
const ScheduleInfoDataValueWrapper = styled_components_1.default(components_1.View).attrs({
    spaceTop: components_1.VIEW_INDENT.xs,
    align: components_1.VIEW_ALIGN.center,
}) `
  width: ${({ labelWidth }) => labelWidth || 'initial'};
`;
const ScheduleInfoDataRow = ({ label, value, labelWidth, tooltipData, }) => {
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row },
        react_1.default.createElement(ScheduleInfoDataValueWrapper, { labelWidth: labelWidth },
            react_1.default.createElement(components_1.Text, null, label)),
        react_1.default.createElement(ScheduleInfoDataValueWrapper, { style: { paddingLeft: 6 } },
            react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.s },
                react_1.default.createElement(components_1.Text, { truncate: true }, value),
                (tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.items.length) && (react_1.default.createElement(components_1.SignPost, { width: "210px" },
                    react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.s },
                        react_1.default.createElement(components_1.Text, null, tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.label),
                        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.xs }, tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.items.map((item, index) => (react_1.default.createElement(components_1.Text, { key: `tooltip-item-${index}` }, item)))))))))));
};
exports.ScheduleInfoDataRow = ScheduleInfoDataRow;
//# sourceMappingURL=ScheduleInfoDataRow.js.map